var handle_array = ["20-volcan-comet","20-retro-e-cruzer-electric-bike","20-street-electric-bike","26-easy-rider-cruiser-ladies","copy-of-volcan-trail-34","volcan-trail-2","26-strata-mountain-bike","27-5-colt-hardtail","volcan-trail","29-amped-electric-mountain-bike","29-colt-hardtail"];
 var productid_array = ["8213965373671","8218004259047","8218048332007","8218100924647","8213963636967","8213963342055","8218107904231","8218097516775","8213952200935","8218025033959","8218072645863"];
 var hide_price=1;
 var hide_ajaxaddtocart=1;
 var display_phone=1;
 var phone_no = '+568932564789';
 var display_call_for_price = 1;
 var call_for_price_label = 'Request for price';
 var css_style_button='';
 var enabled_captcha = 0;
 var site_key = '';
 var recaptcha_ver = 'v2';
 var thankyou_msg = 'Your Request Submitted Successfully.';
 var thankyou_header = 'Success';
 var name_label='Name';
 var email_label='Email';
 var phone_label = ' Phone Number';
 var comment_label = 'Comment';
 var submit_label ='Submit';
  var error_name_label='Please fill out this field.';
 var error_email_label='Please fill out this field.';
 var error_phone_label = 'Please fill out this field.';
 var error_comment_label = 'Please fill out this field.';
 var enable_app =0;
 var enable_outofstock = 1;
 var price_selector='';
 var cart_selector='#AddToCart-product-template';
 var phone_no_label = 'Call for Price';
 var required_field='name,email,comment';
 var contact_form_heading='Price request for';
 var parent_selector='';
 var unavailable_label='';
 var show_price='no';
 var enable_cfp_for_zero_price_prd='yes';
 var enable_cfp_for_all_products='yes';
 var enable_cfp_soldout_products='yes';
 var hide_cfp_btn_on_collection='no';
 var hide_phone_no_on_collection='no';
 var enable_whatsapp = 1;
 var whatsapp_number = '';
 var whatsapp_message = 'Hi  I am interested in this product. {product_url}. Price please ?';
 var hide_whatsapp_button_on_collection = 0;
 var whatsapp_button_text ='Get price on Whatsapp';
 var whatsapp_button_background_color ='#000000';
 var whatsapp_button_text_color ='#ffffff';
 var whatsapp_css_style_button ='';
 var phoneno_css_style_button ='';